import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

import { isLive, VideoModel } from '../../models';

@Component({
  selector: 'app-roots',
  templateUrl: './roots.component.html',
  styleUrls: ['./roots.component.scss']
})
export class RootsComponent implements OnInit {

  public url: string | null = null;
  public isEmbeded: boolean = false;
  constructor(private activatedRoute: ActivatedRoute) { }

  public selectedVideo?: VideoModel;

  private get _videos(): VideoModel[] {
    return [
      {
        name: 'BJJ Jeff',
        pro: {

        },
        thumbUrl: 'https://res.cloudinary.com/dwko3iqjs/image/upload/v1754566314/Ep001-Poll-1-Work_ok2giy.png',
        date: new Date('2025-08-17T14:00:00Z')
      },
      {
        name: 'Bia Bastos',
        pro: {
          url: 'https://youtu.be/R0o-IILmpbs',
          url360: 'https://youtu.be/pp3NxdcQA8M'
        },
        liv: {
          url: 'https://youtu.be/9vaWk0Yxf2U',
          url360: 'https://youtu.be/7rUabQ2_R5k'
        },
        qui: {
          url: 'https://youtu.be/NocuioS1OU4'
        },
        thumbUrl: 'https://res.cloudinary.com/dwko3iqjs/image/upload/v1754860704/Bia-Working-YouTube-360_xr3nuw.png',
        date: new Date('2025-08-10T14:00:00Z')
      },

      {
        name: 'Raul Engel',
        pro: {
          url: 'https://youtu.be/CjKU91cLV3A',
          url360: 'https://youtu.be/D8EkOmUUebU'
        },
        qui: {
          url: 'https://youtu.be/iIgki2GTVWI'
        },
        thumbUrl: 'https://res.cloudinary.com/dwko3iqjs/image/upload/v1754566323/raul-thumb-youtube-work-360_lqi3mk.png',
        date: new Date('2025-08-08T14:00:00Z')
      },
      {
        name: 'Vizzeto - Rafael Work',
        thumbUrl: 'https://res.cloudinary.com/dwko3iqjs/image/upload/v1754223689/Ep008-Rafa-Vizzeto_jsqbi3.png',
        pro: {
          url360: 'https://youtu.be/uw8YOfrRO9Q',
        },
        liv: {
          url360: 'https://youtu.be/LhlPDCxEahs',
        },
        qui: {
          url: 'https://youtu.be/zY6yEYgi4rA',
        },
        date: new Date('2025-08-02T14:00:00Z')
      },
      {
        name: 'O Brasileiro Poll',
        thumbUrl: 'https://res.cloudinary.com/dwko3iqjs/image/upload/v1754566314/Ep001-Poll-1-Work_ok2giy.png',
        pro: {
          url360: 'https://youtu.be/mKk8F1rk424',
        },
        liv: {
          url360: 'https://youtu.be/3pjg6nUHS5Q',
        },
        qui: {
          url: 'https://youtu.be/RGojfKE0wAg',
        },
        date: new Date('2025-08-02T14:00:00Z')
      }
    ].filter(video => video.date < new Date());
  }

  public get videoMain(): VideoModel {
    return this._videos[0];
  }


  public get videosLatest(): VideoModel[] {
    return this._videos.filter((video, index) => index > 0 && index < 3);
  }

  public get videosList(): VideoModel[] {
    return this._videos.filter((video, index) => index >= 3);
  }

  ngOnInit(): void {

    const medium = this.activatedRoute.snapshot.queryParamMap.get('utm_medium')?.toLocaleLowerCase();
    this.isEmbeded = (medium === 'instagram');

    // var isiOS = /iPad|iPhone|iPod/i.test(navigator.userAgent);

    var isAndroid = /Android/i.test(navigator.userAgent);

    if (isAndroid) {
      this.url = 'https://play.google.com/store/apps/details?id=app.nagringa.app';
    } else {
      this.url = 'https://apps.apple.com/au/app/nagringa/id1608557362';
    }

  }

  public isVideoLive(video: VideoModel): boolean {
    return isLive(video);
  }

}
